import styled from 'styled-components'
import {
	FacebookIcon,
	FacebookShareButton,
	LinkedinIcon,
	LinkedinShareButton,
	TelegramIcon,
	TelegramShareButton,
	TwitterShareButton,
	WhatsappIcon,
	WhatsappShareButton,
	XIcon,
} from 'react-share'
import { createManualPathName } from '../../../utils/createPathName'
import { useContext } from 'react'
import { ThemeContext } from '../../../contexts/ThemeContext'

const FloatingManualShareContainer = styled.div<{ isManualShareBoxShown: boolean; isLightTheme: boolean }>`
	position: absolute;
	bottom: 60px;
	width: 100%;
	height: ${(props) => (props.isManualShareBoxShown ? '180px' : '0')};
	overflow: hidden;
	box-shadow: ${(props) =>
		props.isLightTheme
			? '-4px 8px 48px rgba(0, 0, 0, 0.1), 8px 0px 100px rgba(0, 0, 0, 0.02)'
			: '-4px 8px 48px rgba(255, 255, 255, 0.1), 8px 0px 100px rgba(255, 255, 255, 0.02)'};
	border-radius: 16px;
	transition: all 0.2s ease-in-out;

	background: var(--background-color);
`

const FloatingManualShareMenu = styled.div`
	height: 100%;
	background: var(--background-color);
	transition: all 0.2s ease-in-out;

	box-sizing: border-box;

	padding: 20px 20px 40px;
	position: relative;

	& > h6 {
		font-size: 16px;
	}
`

const ManualShareMedia = styled.div`
	margin-top: 10px;
	width: 100%;
	max-width: 250px;
	margin: 10px auto 0;
	display: flex;
	justify-content: center;
	flex-wrap: wrap;
	gap: 15px;
`

interface ManualShareProps {
	isManualShareBoxShown: boolean
	id: number
	manualTitle: string
	date: string
}

const ManualShare = ({ isManualShareBoxShown, id, date, manualTitle }: ManualShareProps) => {
	const { theme } = useContext(ThemeContext)

	let manualId = createManualPathName(manualTitle, date, id)
	const shareUrl = `https://manuals.nlwc.church/manual/${manualId}`

	return (
		<FloatingManualShareContainer isManualShareBoxShown={isManualShareBoxShown} isLightTheme={theme === 'light'}>
			<FloatingManualShareMenu>
				<h6>Share this blessing!</h6>

				<ManualShareMedia>
					<WhatsappShareButton url={shareUrl} title={manualTitle} separator=':: '>
						<WhatsappIcon size={48} round />
					</WhatsappShareButton>

					<TwitterShareButton url={shareUrl} title={manualTitle}>
						<XIcon size={48} round />
					</TwitterShareButton>

					<FacebookShareButton url={shareUrl}>
						<FacebookIcon size={48} round />
					</FacebookShareButton>

					<LinkedinShareButton url={shareUrl}>
						<LinkedinIcon size={48} round />
					</LinkedinShareButton>

					<TelegramShareButton url={shareUrl} title={manualTitle}>
						<TelegramIcon size={48} round />
					</TelegramShareButton>
				</ManualShareMedia>
			</FloatingManualShareMenu>
		</FloatingManualShareContainer>
	)
}

export default ManualShare
